module.exports = __webpack_public_path__ + "static/media/virgin_card_3.1e5828eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/LargeFlightCard/images/virgin_card_3.jpg
// module id = 529
// module chunks = 0